module.exports = __webpack_public_path__ + "0d4d33a0d933ce7945395a08da1d28da.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-32.png
// module id = 2127
// module chunks = 0